import {
  useForm,
  FormProvider,
  FieldValues,
  SubmitHandler,
} from 'react-hook-form';
import styles from '@/components/help/common/FormContainer/FormContainer.module.scss';
import {FormContainerProvider} from '@/components/help/common/FormContainer/FormContainerContext';
import {FormType} from '@/components/help/common/FormContainer/types';

interface WrapperProps {
  children: React.ReactNode;
  onSubmit: SubmitHandler<FieldValues>;
  fieldOrder: string[];
  defaultValues: FieldValues;
  type: FormType;
}

const Wrapper = ({children, onSubmit, defaultValues, type}: WrapperProps) => {
  const methods = useForm({
    mode: 'onTouched',
    defaultValues: defaultValues,
  });

  return (
    <FormContainerProvider type={type}>
      <FormProvider {...methods}>
        <div className={styles.wrapper}>
          <form onSubmit={methods.handleSubmit(onSubmit)}>{children}</form>
        </div>
      </FormProvider>
    </FormContainerProvider>
  );
};

export default Wrapper;
